import {
  vs2ngaLimitedReleaseDetailConstants,
  createVs2ngaLimitedReleaseDetailConstants,
  editVs2ngaLimitedReleaseDetailConstants,
  addTargetVs2ngaLimitedReleaseDetailConstants,
  removeTargetVs2ngaLimitedReleaseDetailConstants,
  activateVs2ngaLimitedReleaseDetailConstants,
  deactivateVs2ngaLimitedReleaseDetailConstants,
  deleteVs2ngaLimitedReleaseDetailConstants,
} from "../_redux-constants";

export function vs2ngaLimitedReleasesDetailReducer(
  state = {
    vs2ngaLimitedReleaseDetailLoading: false,
    vs2ngaLimitedReleaseDetailData: null,
    vs2ngaLimitedReleaseDetailError: null,

    createVs2ngaLimitedReleaseDetailLoading: false,
    createVs2ngaLimitedReleaseDetailData: null,
    createVs2ngaLimitedReleaseDetailError: null,

    editVs2ngaLimitedReleaseDetailLoading: false,
    editVs2ngaLimitedReleaseDetailData: null,
    editVs2ngaLimitedReleaseDetailError: null,

    addTargetVs2ngaLimitedReleaseDetailLoading: false,
    addTargetVs2ngaLimitedReleaseDetailData: null,
    addTargetVs2ngaLimitedReleaseDetailError: null,

    removeTargetVs2ngaLimitedReleaseDetailLoading: false,
    removeTargetVs2ngaLimitedReleaseDetailData: null,
    removeTargetVs2ngaLimitedReleaseDetailError: null,

    activateVs2ngaLimitedReleaseDetailLoading: false,
    activateVs2ngaLimitedReleaseDetailData: null,
    activateVs2ngaLimitedReleaseDetailError: null,

    deactivateVs2ngaLimitedReleaseDetailLoading: false,
    deactivateVs2ngaLimitedReleaseDetailData: null,
    deactivateVs2ngaLimitedReleaseDetailError: null,

    deleteVs2ngaLimitedReleaseDetailLoading: false,
    deleteVs2ngaLimitedReleaseDetailData: null,
    deleteVs2ngaLimitedReleaseDetailError: null,
  },
  action
) {
  switch (action.type) {
    case vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        vs2ngaLimitedReleaseDetailLoading: true,
        vs2ngaLimitedReleaseDetailData: null,
        vs2ngaLimitedReleaseDetailError: null,
      });
    case vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaLimitedReleaseDetailLoading: false,
        vs2ngaLimitedReleaseDetailData: action.data,
      });
    case vs2ngaLimitedReleaseDetailConstants.VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        vs2ngaLimitedReleaseDetailLoading: false,
        vs2ngaLimitedReleaseDetailData: null,
        vs2ngaLimitedReleaseDetailError: action.error,
      });
    case createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        createVs2ngaLimitedReleaseDetailLoading: true,
        createVs2ngaLimitedReleaseDetailData: null,
        createVs2ngaLimitedReleaseDetailError: null,
      });
    case createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        createVs2ngaLimitedReleaseDetailLoading: false,
        createVs2ngaLimitedReleaseDetailData: action.data,
      });
    case createVs2ngaLimitedReleaseDetailConstants.CREATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        createVs2ngaLimitedReleaseDetailLoading: false,
        createVs2ngaLimitedReleaseDetailData: null,
        createVs2ngaLimitedReleaseDetailError: action.error,
      });
    case editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        editVs2ngaLimitedReleaseDetailLoading: true,
        editVs2ngaLimitedReleaseDetailData: null,
        editVs2ngaLimitedReleaseDetailError: null,
      });
    case editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        editVs2ngaLimitedReleaseDetailLoading: false,
        editVs2ngaLimitedReleaseDetailData: action.data,
      });
    case editVs2ngaLimitedReleaseDetailConstants.EDIT_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        editVs2ngaLimitedReleaseDetailLoading: false,
        editVs2ngaLimitedReleaseDetailData: null,
        editVs2ngaLimitedReleaseDetailError: action.error,
      });
    case addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        addTargetVs2ngaLimitedReleaseDetailLoading: true,
        addTargetVs2ngaLimitedReleaseDetailData: null,
        addTargetVs2ngaLimitedReleaseDetailError: null,
      });
    case addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        addTargetVs2ngaLimitedReleaseDetailLoading: false,
        addTargetVs2ngaLimitedReleaseDetailData: action.data,
      });
    case addTargetVs2ngaLimitedReleaseDetailConstants.ADD_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        addTargetVs2ngaLimitedReleaseDetailLoading: false,
        addTargetVs2ngaLimitedReleaseDetailData: null,
        addTargetVs2ngaLimitedReleaseDetailError: action.error,
      });
    case removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        removeTargetVs2ngaLimitedReleaseDetailLoading: true,
        removeTargetVs2ngaLimitedReleaseDetailData: null,
        removeTargetVs2ngaLimitedReleaseDetailError: null,
      });
    case removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        removeTargetVs2ngaLimitedReleaseDetailLoading: false,
        removeTargetVs2ngaLimitedReleaseDetailData: action.data,
      });
    case removeTargetVs2ngaLimitedReleaseDetailConstants.REMOVE_TARGET_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        removeTargetVs2ngaLimitedReleaseDetailLoading: false,
        removeTargetVs2ngaLimitedReleaseDetailData: null,
        removeTargetVs2ngaLimitedReleaseDetailError: action.error,
      });
    case activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        activateVs2ngaLimitedReleaseDetailLoading: true,
        activateVs2ngaLimitedReleaseDetailData: null,
        activateVs2ngaLimitedReleaseDetailError: null,
      });
    case activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        activateVs2ngaLimitedReleaseDetailLoading: false,
        activateVs2ngaLimitedReleaseDetailData: action.data,
      });
    case activateVs2ngaLimitedReleaseDetailConstants.ACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        activateVs2ngaLimitedReleaseDetailLoading: false,
        activateVs2ngaLimitedReleaseDetailData: null,
        activateVs2ngaLimitedReleaseDetailError: action.error,
      });
    case deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deactivateVs2ngaLimitedReleaseDetailLoading: true,
        deactivateVs2ngaLimitedReleaseDetailData: null,
        deactivateVs2ngaLimitedReleaseDetailError: null,
      });
    case deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deactivateVs2ngaLimitedReleaseDetailLoading: false,
        deactivateVs2ngaLimitedReleaseDetailData: action.data,
      });
    case deactivateVs2ngaLimitedReleaseDetailConstants.DEACTIVATE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deactivateVs2ngaLimitedReleaseDetailLoading: false,
        deactivateVs2ngaLimitedReleaseDetailData: null,
        deactivateVs2ngaLimitedReleaseDetailError: action.error,
      });
    case deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_LOADING:
      return Object.assign({}, state, {
        deleteVs2ngaLimitedReleaseDetailLoading: true,
        deleteVs2ngaLimitedReleaseDetailData: null,
        deleteVs2ngaLimitedReleaseDetailError: null,
      });
    case deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_SUCCESS:
      return Object.assign({}, state, {
        deleteVs2ngaLimitedReleaseDetailLoading: false,
        deleteVs2ngaLimitedReleaseDetailData: action.data,
      });
    case deleteVs2ngaLimitedReleaseDetailConstants.DELETE_VS2NGA_LIMITED_RELEASE_DETAIL_FAILURE:
      return Object.assign({}, state, {
        deleteVs2ngaLimitedReleaseDetailLoading: false,
        deleteVs2ngaLimitedReleaseDetailData: null,
        deleteVs2ngaLimitedReleaseDetailError: action.error,
      });
    default:
      return state;
  }
}
